import { gravityLockData } from "constants-lib/seo/gravityLockData"
import { addJSONLDToHead, removeElement } from "./jsonLD.js"

export const getGravityLockData = (schemaData) => {
  const data = schemaData.map((item) => ({
    "@type": `Question`,
    name: item.Question,
    acceptedAnswer: {
      "@type": `Answer`,
      text: item.Answer,
    },
  }))
  return data
}

/* Add Gravity Lock JSON LD if needed, otherwise make sure it does not exist in Head. */
export const addGravityLockData = () => {
  if (
    window.location.href.includes(
      `/us/en/support/faqs/video-can-you-show-me-what-a-gravity-lock-is-and-how-it-works`,
    ) &&
    document.getElementById(`gravityLock`) === null
  ) {
    const script = gravityLockJSONLD()
    addJSONLDToHead(script, `gravityLock`)
  } else {
    removeElement(`gravityLock`)
  }
}

// JSON LD template for Gravity Lock
const gravityLockJSONLD = () => {
  const gravityLockTemplate = {
    "@context": `http://schema.org`,
    "@type": `FAQPage`,
    mainEntity: getGravityLockData(gravityLockData),
  }
  return gravityLockTemplate
}
